import apiClient from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { isNewLoggedInAccount } from '../http/endpointStateChecks';
import { getHublet, getIsNewUser } from '../store/app/selectors';
import { getAuthUserId, getPortalId } from '../store/auth/selectors';
import { isExistingUser, isExistingUserExistingAccount } from '../app/verificationTypeSelectors';
export const shouldUpdateTrellisTheme = state => {
  return isNewLoggedInAccount(state) && getIsNewUser(state) || isExistingUser(state) && isNewLoggedInAccount(state) && !isExistingUserExistingAccount(state);
};
export const updateTrellisTheme = state => {
  const portalId = getPortalId(state);
  const hublet = getHublet(state);
  const userId = getAuthUserId(state);
  const requestUrl = `${getFullUrl('api', {
    hubletOverride: hublet
  })}/chirp-frontend-app-slow/v1/gateway/com.hubspot.frontend.app.usersettings.rpc.UserSettingsRpc/updateUserThemeSetting`;
  return apiClient.post(requestUrl, {
    portalId,
    userId,
    data: {
      themeName: 'TRELLIS_LIGHT'
    }
  });
};